// Fixture data for the client-hub demos (home hero widget, /demos mock).
// One source so the two renderings never drift apart.

export const PROJECT_NAME = 'Nighthouse v2 build';

export const PHASES = [
  { id: 'scope', label: 'Scoping & discovery', status: 'done', progress: 100, eta: 'Done', tech: ['Scope doc', 'Quote'], details: 'Problem framing, user stories and a fixed price signed off.' },
  { id: 'design', label: 'UI/UX design', status: 'done', progress: 100, eta: 'Done', tech: ['Figma', 'Design system'], details: 'Every screen and state, on brand, reviewed before code.' },
  { id: 'build', label: 'API development', status: 'active', progress: 67, eta: '5 days left', tech: ['Node', 'SQLite', 'Stripe'], details: 'Auth, CRUD endpoints, payments and third-party integrations.' },
  { id: 'qa', label: 'QA & testing', status: 'next', progress: 0, eta: 'After build', tech: ['Playwright', 'node:test'], details: 'End-to-end flows, unit tests and a load test on staging.' },
  { id: 'launch', label: 'Launch & handoff', status: 'next', progress: 0, eta: '2 weeks', tech: ['VPS', 'pm2', 'CI'], details: 'Production deploy on your domain, docs and source handoff.' },
];

export const DELIVERABLES = [
  { label: 'Statement of work v2', status: 'delivered', date: 'Jan 10' },
  { label: 'Figma design system', status: 'delivered', date: 'Jan 14' },
  { label: 'Database schema', status: 'delivered', date: 'Jan 18' },
  { label: 'Auth + onboarding flow', status: 'delivered', date: 'Jan 22' },
  { label: 'Core API endpoints', status: 'review', date: 'Jan 28' },
  { label: 'Admin dashboard', status: 'building', date: 'Feb 2' },
  { label: 'Mobile responsive pass', status: 'pending', date: 'Feb 7' },
  { label: 'QA report + fixes', status: 'pending', date: 'Feb 12' },
];

export const LAUNCH_CHECKLIST = [
  { label: 'Staging environment', done: true },
  { label: 'Production environment', done: true },
  { label: 'Domain + SSL', done: true },
  { label: 'Error monitoring', done: false },
  { label: 'Analytics + conversion events', done: false },
  { label: 'Backups + CI pipeline', done: false },
  { label: 'Source code handoff', done: false },
];

export const VELOCITY_STATS = [
  { label: 'Velocity', value: '94%' },
  { label: 'On track', value: '4/5' },
  { label: 'Blockers', value: '0' },
];

export const OVERALL_PROGRESS = Math.round(PHASES.reduce((sum, p) => sum + p.progress, 0) / PHASES.length);

export const PHASE_STATUS = {
  done: { label: 'Completed', cls: 'text-sky bg-cobalt/20' },
  active: { label: 'In progress', cls: 'text-amber bg-amber/15' },
  next: { label: 'Upcoming', cls: 'text-dim bg-white/5' },
};

export const DELIVERABLE_STATUS = {
  delivered: { label: 'Delivered', cls: 'text-sky bg-cobalt/20' },
  review: { label: 'In review', cls: 'text-amber bg-amber/15' },
  building: { label: 'Building', cls: 'text-cream bg-white/10' },
  pending: { label: 'Pending', cls: 'text-dim bg-white/5' },
};
